export const formatNumber = (value) => Number(value).toLocaleString('en-US');
export const formatDuration = (ms) => ms >= 1000 ? (ms / 1000).toFixed(1) + ' s' : ms + ' ms';

export const buildStatsSections = (stats, session) => {
    const sections = [];

    if (stats) {
        const truncated = stats.finish_reason && stats.finish_reason !== 'stop';
        const tokensQuota = stats.rate_limits?.tokens;
        const requestsQuota = stats.rate_limits?.requests;

        sections.push({
            title: 'Tokens',
            rows: [
                ['Total', formatNumber(stats.total_tokens)],
                ['Input (prompt)', formatNumber(stats.prompt_tokens)],
                ['Output (answer)', formatNumber(stats.completion_tokens)],
            ],
        });
        sections.push({
            title: 'Time',
            rows: [
                ['Total duration', formatDuration(stats.duration_ms)],
                ['OpenAI processing', stats.processing_ms !== null && stats.processing_ms !== undefined ? formatDuration(stats.processing_ms) : null],
            ],
        });
        sections.push({
            title: 'Request',
            rows: [
                ['Model', stats.model],
                ['AI calls', stats.calls],
                ['Corrections', stats.repairs],
                ['Stop reason', stats.finish_reason ? { text: stats.finish_reason, warning: truncated } : null],
            ],
            note: truncated ? 'The answer may have been cut off or filtered.' : null,
        });
        if (stats.attempts && stats.attempts.length > 1) {
            sections.push({
                title: 'Calls detail',
                rows: stats.attempts.map((attempt, index) => [
                    'Call ' + (index + 1),
                    formatNumber(attempt.total_tokens) + ' tokens · ' + formatDuration(attempt.duration_ms) + (attempt.rejection ? ' · rejected: ' + attempt.rejection : ' · accepted'),
                ]),
                stacked: true,
            });
        }
        if (tokensQuota || requestsQuota) {
            sections.push({
                title: 'API key quota',
                rows: [
                    ['Tokens left', tokensQuota ? formatNumber(tokensQuota.remaining) + (tokensQuota.limit ? ' / ' + formatNumber(tokensQuota.limit) : '') : null],
                    ['Tokens reset in', tokensQuota ? tokensQuota.reset : null],
                    ['Requests left', requestsQuota ? formatNumber(requestsQuota.remaining) + (requestsQuota.limit ? ' / ' + formatNumber(requestsQuota.limit) : '') : null],
                ],
            });
        }
        sections.push({ title: 'Request ID', rows: [[null, stats.request_id ? { text: stats.request_id, mono: true } : null]], stacked: true });
    }

    if (session && session.requests > 0) {
        sections.push({
            title: 'Session total',
            rows: [
                ['Requests', session.requests],
                ['AI calls', session.calls],
                ['Tokens', formatNumber(session.tokens)],
            ],
        });
    }

    return sections;
};
